
import {
  Component, ViewChild, ElementRef, OnInit, NgZone,
  Input, Renderer, DoCheck, Output, EventEmitter, AfterViewInit, NgModule, OnDestroy, ComponentRef
} from '@angular/core';
import { Router, ActivatedRoute, RouterStateSnapshot } from '@angular/router';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { MapsAPILoader } from '@agm/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../models/app.state';
import { environment } from '../../../environments/environment';
import { HttpService } from '../../service/http.service';
import { LoadingComponent } from "../loading/loading.component";
import { Subject } from "rxjs";
import { PostFilterService } from '../../service/post-filter.service';
import 'jquery';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { ADD_BUILDING, JOIN_BUILDING } from 'src/app/reducers/building.reducers';
declare var $: any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit, DoCheck, AfterViewInit, OnDestroy {

  address: any = {};
  inputAddress;
  searchForm: FormGroup;
  reportCoop: FormGroup;
  modalWindow;
  unregisteredAddress;
  submited: boolean;
  modalDismiss: string;
  coords: Object = {};
  imageUrl;
  error;
  addressInput;
  place: google.maps.places.PlaceResult;
  isLoadingActive = false;
  isSuccess = false;
  successMessage: string;
  alert;
  ModalTrigger = false;
  modalToOpen;
  modalTarget;
  errorState: boolean = false;


  emailInvalid = false;
  commentInvalid = false;
  submitted: boolean = false;

  homeComponentRef: ComponentRef<HomeComponent>;

  @ViewChild('search', { static: false })
  public searchElementRef: ElementRef;

  @ViewChild('submitbuild', { static: false })
  public submit: ElementRef;

  @ViewChild('loginButton', { static: false })
  public log: ElementRef;
  test;

  tags: string[] = ['AngularJS', 'Angluar2']


  constructor(private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone,
    private router: Router,
    private _fb: FormBuilder,
    private _http: HttpClient,
    private httpService: HttpService,
    private store: Store<AppState>,
    private renderer: Renderer,
    private route: ActivatedRoute,
    private param: PostFilterService
  ) { }

  ngOnInit() {
    $(document).ready(function () {
      $('.modal-backdrop.fade.in').remove();
    })
    //mycoop report form
    this.reportCoop = this._fb.group({
      'email': new FormControl('', [Validators.required,
      Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]),
      'comments': new FormControl('', Validators.required)
    });

    this.mapsAPILoader.load().then(() => {
      const autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {
        types: []
      });
      autocomplete.addListener('place_changed', () => {
        this.ngZone.run(() => {
          //get the place result

          this.error = null;
          this.place = autocomplete.getPlace();
          console.log(this.place);
          this.addressInput = this.place.formatted_address;
          this.renderer.listen(this.submit.nativeElement, 'click', (event) => {

            this.address.adr_address = this.place['adr_address'];
            this.address.formattedAddress = this.place.formatted_address;
            this.address.coords = {
              lat: this.place.geometry.location.lat(),
              lng: this.place.geometry.location.lng()
            };
            this.address.placeId = this.place.place_id;

            console.log(this.place.formatted_address, this.addressInput);
            console.log(this.place.formatted_address === this.addressInput);
            if (this.addressInput == '') {
              //console.log(this.inputAddress, this.addressInput, 'condition1');
              this.modalWindow = null;
              this.error = 'Please enter your building address';
              this.unregisteredAddress = this.addressInput;
            } else if (this.place.formatted_address !== this.addressInput) {
              this.error = null;

              this.modalWindow = '#myModal';
            }
            else {
              this.modalWindow = '';
              const header = new Headers();
              header.append('Content-Type', 'application/json');
              this._http.post(environment.apiUrl + 'mycoopbuildings/findmyCoopBuilding',
                { address: this.address },
                { withCredentials: true }
              ).pipe(
                map((data: any) => data)
              ).subscribe(data => {
                console.log(data);

                this.store.dispatch({ type: JOIN_BUILDING, payload: <any>{ address: data } });
                this.router.navigate(['/building']);
              },
                (error) => {
                  console.log(this.address);

                  this.store.dispatch({ type: ADD_BUILDING, payload: <any>{ address: this.address } });
                  this.router.navigate(['/building', 'addbuilding']);
                  //this.buttonWasClicked.emit(this.value);
                  // this.modalWindow="";
                });

              //this.address = undefined;
            }
          });
          //this.address = place.address_components;

          //verify result
          if (this.place.geometry === undefined || this.place.geometry === null) {
            return;
          }
          if (this.place.photos) {
            this.imageUrl = this.place.photos[0].getUrl({ 'maxWidth': 128, 'maxHeight': 128 });
            console.log(this.imageUrl);
          } else {
            this.imageUrl = '';
          }
          this.coords = {
            lat: this.place.geometry.location.lat(),
            lng: this.place.geometry.location.lng()
          };

        });
      });
    }).catch((error) => {
      console.log(error, 'fffffffffff')
      $('#myModal').modal('show');

    });

    //this.emailInvalid = (this.reportCoop.get('email').invalid && this.reportCoop.get('email').touched);
    //this.commentInvalid = this.reportCoop.get('comments').invalid && this.reportCoop.get('comment').touched;

    if (this.reportCoop.get('email').invalid && this.reportCoop.get('email').touched) {
      this.emailInvalid = true;
    } else {
      this.emailInvalid = false;
    }

    if (this.reportCoop.get('comments').invalid && this.reportCoop.get('comments').touched) {
      this.commentInvalid = true;
    } else {
      this.commentInvalid = false;
    }




  }

  ngAfterViewInit() {

    let modalParam = this.route.queryParams;
    this.error = this.route.snapshot.queryParams['error'];
    let deactivatedUser = this.route.snapshot.queryParams['exist'];
    console.log(modalParam, this.error, 'hello')
    if (this.error == "err" && !deactivatedUser) {
      //$("#loginForm").modal('show');
      this.error = "Please create your account";
    } else if (this.error == "err" && deactivatedUser) {
      //$("#loginForm").modal('show');
      this.error = "Please activate your account";
    }


    this.param.currentMessage2.subscribe((res) => {
      if (res == 'open') {
        $(document).ready(function () {
          $('#loginForm').modal('show');
        })


      }
    }).unsubscribe()

  }

  ngOnDestroy() {

    $('#loginForm').modal('hide');
    if (this.homeComponentRef) {
      this.homeComponentRef.destroy();
    }

  }

  setCurrentPosition() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {

        const geocoder = new google.maps.Geocoder();
        const that = this;
        const latlng = { lat: position.coords.latitude, lng: position.coords.longitude };
        geocoder.geocode({ 'location': latlng }, (results, status) => {
          $('.autocomplete').val(
            results[0].formatted_address.substring(0, 30));
          $('.autocomplete').focus();
          this.address.formattedAddress = results[0].formatted_address;

          this.addressInput = results[0].formatted_address;

          //this.addressInput =this.addressInput.substring(1,4);
          console.log(results)
        })

      });

    }
  }


  buildingSearch() {
    console.log(this.addressInput, this.place);
    this.submitted = false;
    this.reportCoop.reset(); this.reportCoop.markAsUntouched();
    if (this.addressInput == undefined || this.addressInput.trim() == '') {
      this.error = 'Please enter your address';
    } else if (this.addressInput.length > 0 && this.place == undefined) {
      this.error = null;
      this.modalWindow = "#myModal";
    } else {
      this.error = null;
      this.modalWindow = null;
    }
  }
  addressNotFindReport() {
    if (this.inputAddress == undefined && this.addressInput == undefined) {
      this.error = "please enter your address";
    } else if (this.addressInput != undefined) {
      console.log(this.addressInput)
    }
  }

  ngDoCheck() {
    // $('.modal-backdrop').remove();
  }

  clearError(field) {
    if (field === 'email') {
      this.emailInvalid = false;
    } else if (field === 'comment') {
      this.commentInvalid = false;
    }
  }

  reportMycoop() {
    this.submitted = true;
    console.log(this.reportCoop.get('email').hasError('required'), this.reportCoop.get('comments').hasError('required'));

    this.emailInvalid = this.reportCoop.get('email').hasError('required');
    this.commentInvalid = this.reportCoop.get('comments').hasError('required') || this.reportCoop.get('comments').value.trim().length <= 0;

    if (this.reportCoop.valid && !this.emailInvalid && !this.commentInvalid) {
      this.isLoadingActive = true;
      const reportForm = {
        formValue: this.reportCoop.value,
        conflictAddress: this.addressInput
      };

      this.httpService.reportAddressToMycoop(reportForm).subscribe(
        (response) => {
          if (response) {
            this.isLoadingActive = false;
          }
          if (response.ok) {
            this.isSuccess = true;
            this.successMessage = 'Thank you for reporting your issue.  Someone from mycoop will follow up with you shortly!';
            this.reportCoop.reset();
          }
          console.log(response.ok);
        },
        (error) => {
          console.log(error);
        }
      );
    }

  }

  closeDialog() {
    setTimeout(() => {
      this.isSuccess = false;
    }, 1000);
  }

  scrollFunction() {
    const the_id = document.getElementById('scrollToSection');
    $('html, body').animate({
      scrollTop: $(the_id).offset().top
    }, 'slow');


  }

  reloadCurrentRoute() {
    this.router.navigate([this.router.url], { skipLocationChange: true });
  }

  closeLoginModal(type) {
    if (type == 'signUp') {
      $('#loginForm').modal('hide');
      this.alert = "Please select your address to proceed sign up";
    } else {
      $('#loginForm').modal('hide');
      this.alert = null;
    }


  }
  show(event) {
    this.errorState = true;
    console.log(event, '.....');
    if (event.val1 && event.val2) {
      $('#loginForm').modal('hide');
    }

    if (event == 'forgotModal') {
      $('#loginForm').modal('hide');
      this.router.navigate(['building', 'forgotPassword']);
    }

  }

  modalTriggerMethod() {
    this.error = null;
    this.ModalTrigger = true;
    this.errorState = false;
    this.modalTarget = "#loginForm"
  }

}
